<template>
  <div class="index">
    <a-row>
      <a-col :span="24" style="font-size: 18px">
      <!-- 以下为您参与的项目，请选择需要进入的项目 -->
        
        <!--下面这段注释不删-->
        <!--<a-select placeholder="请选择项目状态" v-model="projectStatus" @change="statusChange" style="min-width: 150px" allowClear>-->
          <!--<template v-for="(item,index) in statusData">-->
            <!--<a-select-option  v-if="index!=='1' && index!=='5'" :key="index" :value="index">-->
              <!--{{ item.text }}-->
            <!--</a-select-option>-->
          <!--</template>-->
        <!--</a-select>-->
      </a-col>
    </a-row>
      <a-space v-if="projectList && projectList.length>0" >
        <div class="project" v-for="project in projectList" :key="project.id">
          <div class="btn">
            <a-button :loading="loading" type="primary" size="large" style="width: 200px" @click="projectClick(project)"> 点击进入 </a-button>
          </div>
          <div class="project-top">
            <a-row type="flex" justify="space-between">
              <a-col :span="4" style="padding-top: 20px">
                <a-icon type="database" style="font-size: 45px" theme="filled" />
              </a-col>
              <a-col :span="18">
                <a-tooltip class="project-row" @click="projectClick(project)">
                  <template slot="title">
                    {{project.name}}
                  </template>
                  <div class="project-title">
                    {{project.name}}
                  </div>
                </a-tooltip>
                <div class="project-row" style="color: green">
                  <project-status :status="project.status"></project-status>
                </div>
              </a-col>
            </a-row>

            <a-tooltip class="project-row">
              <template slot="title">
                {{project.intro}}
              </template>
              <div class="project-row project-jj">
                <label class="project-title-label">项目简介：</label>
                <label >
                  {{project.intro}}
                </label>
              </div>
            </a-tooltip>

            <div class="project-row"><label  class="project-title-label">负责人：</label><label>{{project.contactName}}</label></div>
          </div>
          <div class="project-item-panel">
            <template  v-for="(info,index) in project.infoList" >
              <a-row :gutter="20" class="project-item-row" v-if="roleData[info.role]" :key="index">
                <a-col :span="12" class="project-item-border ">
                  <div class="project-item-label">我的角色</div>
                  <div class="project-item-value">{{roleData[info.role]}}</div>
                </a-col>
                <!-- <template v-for="(item,ii) in info">
                  <template v-if="ii!=='role'">
                    <a-col v-if="ii!=='groupPatientNum'" :span="12" class="project-item-border project-item-border2 " @click="goItemViewHandle(project,ii)">
                      <div class="project-item-label">{{ii}}</div>
                      <div class="project-item-value">{{item}}</div>
                    </a-col>
                    <template v-else>
                      // 这下面是各个队列的人数
                      <a-col :span="12" class="project-item-border" v-for="(group,gi) in item "  >
                        <div class="project-item-label">{{group.name}}</div>
                        <div class="project-item-value">{{group.num}}</div>
                      </a-col>
                    </template>
                  </template>
                </template> -->
                <a-col :span="12" class="project-item-border" v-if="getKeys(info) % 2 !==0">
                    
                </a-col>
              </a-row>
            </template>
          </div>
        </div>
      </a-space>
    <a-empty v-else />
  </div>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME,statusData } from '@/constants/project'
  import { roleData } from '@/constants/projectRole'
  import Vue from 'vue'
  import ProjectStatus from '@/views/management/project/projectList/ProjectStatus'

  import store from '@/store'

  export default {
    name: 'Index',
    components: { ProjectStatus },
    data(){
      return {
        adminRole:window._CONFIG.adminRole,
        statusData:statusData,
        projectStatus:undefined,
        projectList:[],
        roleData:roleData,
        loading:false
      }
    },
    mounted(){
      Vue.ls.remove(CACHE_PROJECT_ID)
      Vue.ls.remove(CACHE_PROJECT_NAME)
      this.loadData()
    },
    methods:{
      loadData(){
        getAction('/management/project/listByUser',{status: this.projectStatus}).then(res=>{
          if(res.success){
            this.projectList = res.result
          }
        })
      },
      statusChange(){
        // console.log(this.projectStatus)
        this.loadData()
      },
      projectClick(project,url){
        // if(project.status=='4'){
        //   return this.$message.warning('当前项目为暂停中');
        // }
        Vue.ls.set(CACHE_PROJECT_ID,project.id)
        Vue.ls.set(CACHE_PROJECT_NAME,project.name)
        this.loading = true
        store.dispatch('GetPermissionList').then(res=>{
          if(url){
            this.$router.push({path:url})
          }else{
            this.$router.push({path:this.$route.query.redirect || '/home'})
          }
        }).finally(()=>{
          this.loading  = false
        })
      },
      getKeys(obj){
        let int  = 0
        for (let key in obj){
          if(key ==='groupPatientNum'){
            int += obj[key].length
          }else{
            int++;
          }
        }
        return int
      },
      goItemViewHandle(project,name){
        switch (name) {
          case '待审核表单数':
            this.projectClick(project,'/project/datacheck/check')
            break
          case '待审核疑问回复数':
            this.projectClick(project,'/project/datacheck/check')
            break
          case '待回复质疑数':
            this.projectClick(project,'/project/datacheck/question')
            break
          case '当前可随访表单数':
            this.projectClick(project,'/project/patient/register')
            break
          case '当前可执行随访人数':
            this.projectClick(project,'/project/patient/register')
            break
          case '3天内表单过期数':
            this.projectClick(project,'/project/patient/register')
            break
          // case '当前可随访表单数':
          //   this.projectClick(project,'/project/patient/register')
          //   break
          case '':
            break
        }

      },
    }
  }
</script>

<style scoped lang="less">
  .index{
    padding: 20px;
    overflow-y: hidden;
    height: calc(100vh - 60px);
  }
  .project{
    width: 400px;
    margin-top: 20px;
    background-color: white;
    position: relative;
    padding: 20px;
    .btn{
      position: absolute;
      bottom: 10px;
      text-align: center;
      width: calc(100% - 60px);
    }
  }
  .project-top{
    padding-left: 20px;
    padding-right: 20px;
    .project-row{
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .project-title{
      cursor: pointer;
      font-size: 24px;
      height: 30px;
      overflow:hidden;
      white-space: nowrap;//内容超出不换行
      text-overflow: ellipsis;
    }
    .project-title-label{
      font-weight: bold;
    }
    .project-description{
      height: 24px;
      overflow:hidden;
      white-space: nowrap;//内容超出不换行
      text-overflow: ellipsis;
    }
    .project-jj{
      height: 18px;
      overflow:hidden;
      white-space: nowrap;//内容超出不换行
      text-overflow: ellipsis;
    }

  }
  .project-item-panel::-webkit-scrollbar {  //此为核心
    display: none;
  }

  .project-item-panel{
    height: calc(100vh - 330px);
    overflow-y: auto;
    .project-item-border{
      border-top: solid 1px rgba(0,0,0,0.1);
      border-right: solid 1px rgba(0,0,0,0.1);
      height: 70px;
      padding: 10px;
    }
    .project-item-border2{
      cursor: pointer;
    }
    .project-item-border2:hover{
      border: solid 1px @primary-color !important;
    }
    .project-item-label{
      color:  rgba(0,0,0,0.4);
    }
    .project-item-value{
      font-size: 18px;
    }
    .project-item-row{
      margin-bottom: 20px;
      border-bottom: solid 1px rgba(0,0,0,0.1);

    }
  }

</style>